import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const selectVariants = cva(
  "w-full outline-none transition-colors disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-sands-50 border border-sands-200 rounded-lg px-2 py-1.5 text-sm text-sands-700 focus:ring-2 focus:ring-healing-300",
        sm: "bg-sands-50 border border-sands-200 rounded-lg px-2 py-1 text-xs text-sands-700 focus:ring-2 focus:ring-healing-300",
        dashed:
          "bg-sands-50 border border-dashed border-sands-300 rounded-lg px-2 py-1.5 text-xs text-sands-500 focus:ring-2 focus:ring-healing-300 hover:border-healing-400 cursor-pointer",
        inline:
          "text-xs bg-white border border-sands-200 rounded px-2 py-1 text-sands-700 focus:ring-2 focus:ring-healing-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface SelectProps
  extends SelectHTMLAttributes<HTMLSelectElement>,
    VariantProps<typeof selectVariants> {}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, variant, ...props }, ref) => (
    <select
      className={cn(selectVariants({ variant }), className)}
      ref={ref}
      {...props}
    />
  ),
);
Select.displayName = "Select";

export { selectVariants };
